import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SolicitudPacService {

  token: string = '';
  baseUrl = environment.apiEndpoint;



  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  listaSolicitudPacActivos(id: string, estadoId: number): Observable<any> {
    return this.http.get(this.baseUrl + 'listaSolicitudPacActivos/' + id + '/' + estadoId, { headers: this.header(this.token) });
  }

  listaTipoInscripcion(): Observable<any> {
    return this.http.get(this.baseUrl + 'listaTipoInscripcion', { headers: this.header(this.token) });
  }

  listaTipoInformacion(): Observable<any> {
    return this.http.get(this.baseUrl + 'listaTipoInformacion', { headers: this.header(this.token) });
  }

  postSolicitudPac(data: any): Observable<any> {
    return this.http.post(this.baseUrl + 'solicitudPac', data, { headers: this.header(this.token) });
  }

  putSolicitudPac(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'solicitudPac', bodyString, { headers: this.header(this.token) });
  }

  deleteSolicitud(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'eliminarSolicitudPac/' + id, { headers: this.header(this.token) });
  }

  putCambiosEstadoSolicitud(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'cambioEstadoPAC', bodyString, { headers: this.header(this.token) });
  }


}

